export const CHECKOUT_ADDONS_STORAGE_KEY = 'checkoutAddons';

export type CheckoutAddonSelection = {
  code: string;
  selection_type: 'recurring' | 'one_time';
};

export function addonDisplayCodeToApiCode(displayCode: string): string {
  return displayCode.replace(/-/g, '_').toUpperCase();
}

function isCheckoutAddonSelectionList(x: unknown): x is CheckoutAddonSelection[] {
  if (!Array.isArray(x) || x.length === 0) {
    return false;
  }
  return x.every(
    (item) =>
      item !== null &&
      typeof item === 'object' &&
      typeof (item as CheckoutAddonSelection).code === 'string' &&
      ((item as CheckoutAddonSelection).selection_type === 'recurring' ||
        (item as CheckoutAddonSelection).selection_type === 'one_time')
  );
}

export function resolveCheckoutAddonsForRequest(routerState: unknown): CheckoutAddonSelection[] | undefined {
  if (routerState && typeof routerState === 'object' && 'checkoutAddons' in routerState) {
    const raw = (routerState as { checkoutAddons?: unknown }).checkoutAddons;
    if (Array.isArray(raw) && raw.length === 0) {
      return [];
    }
    if (isCheckoutAddonSelectionList(raw)) {
      return raw;
    }
  }
  return readCheckoutAddonsFromStorage();
}

export function readCheckoutAddonsFromStorage(): CheckoutAddonSelection[] | undefined {
  const parseRaw = (raw: string | null): CheckoutAddonSelection[] | undefined => {
    if (!raw) return undefined;
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed) || parsed.length === 0) return undefined;
    return parsed as CheckoutAddonSelection[];
  };

  try {
    const local = parseRaw(localStorage.getItem(CHECKOUT_ADDONS_STORAGE_KEY));
    if (local) return local;
    const session = parseRaw(sessionStorage.getItem(CHECKOUT_ADDONS_STORAGE_KEY));
    if (session) return session;
    return undefined;
  } catch {
    return undefined;
  }
}

export function clearCheckoutAddonsStorage(): void {
  try {
    localStorage.removeItem(CHECKOUT_ADDONS_STORAGE_KEY);
    sessionStorage.removeItem(CHECKOUT_ADDONS_STORAGE_KEY);
  } catch {
  }
}
